module.exports = __webpack_public_path__ + "img/321.39870ee9.jpg";